"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Figure = void 0;
const Figure = 'figure';
exports.Figure = Figure;
//# sourceMappingURL=figure.js.map